export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_GDM_2.e833ed79.jpg";